import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";

export const EndUserMenuItems = [
  {
    name: "منتظر تایید",
    route: "/waiting-list",
    isActive: "waiting-list",
    icon: AccessTimeIcon,
  },
  {
    name: "تایید شده",
    route: "/confirmed-list",
    isActive: "confirmed-list",
    icon: ThumbUpOffAltIcon,
  },
  {
    name: "رد شده",
    route: "/failed-list",
    isActive: "failed-list",
    icon: ThumbDownOffAltIcon,
  },
];
